import Alpine from 'alpinejs'
import Swiper from 'swiper'
import {
  Navigation,
  EffectFade,
  Keyboard,
  Pagination,
  Controller,
  Autoplay,
  Thumbs,
  FreeMode,
} from 'swiper/modules'

import fslightbox from 'fslightbox'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade'
import 'swiper/css/pagination'
import 'swiper/css/controller'
import 'swiper/css/keyboard'
import 'swiper/css/autoplay'
import 'swiper/css/thumbs'

window.Swiper = Swiper
window.Navigation = Navigation
window.SwiperNavigation = Navigation
window.EffectFade = EffectFade
window.Keyboard = Keyboard
window.Pagination = Pagination
window.Controller = Controller
window.Autoplay = Autoplay
window.Thumbs = Thumbs
window.FreeMode = FreeMode

window.Alpine = Alpine

Alpine.start()

document.addEventListener('DOMContentLoaded', () => {
  refreshFsLightbox()
})

console.log('main.js loaded')
